// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"55":"8fdff3d7","117":"10ba54c5","119":"88849d31","326":"9d665127","358":"14f8f730","806":"8a2afaaa","915":"eed26880"}[chunkId] + ".js";
};